import { BigProduct } from '../../Product';
import { LoaderIcon } from '../../../../utils/svg';
import { useMemo } from 'react';
import useProduct from '../../../hook/useProduct';

const TopMenu = (props) => {
	const { gps } = props;
	const { isLoading, products, selectedCategory } = useProduct();

	const filteredProduct = useMemo(() => {
		if (!products?.length) return [];

		let result = products.filter((p) => p?.product_recommendation === 'Yes');

		if (selectedCategory && selectedCategory !== 'all') {
			result = result.filter((product) => selectedCategory === product?.pro_cate_slug);
		}

		return result;
	}, [products, selectedCategory]);

	return (
		<div className={`h-full ${!filteredProduct?.length && !isLoading && 'hidden'}`}>
			{isLoading ? (
				<div className='w-full h-16 flex justify-center items-center'>
					<LoaderIcon />
				</div>
			) : (
				<>
					<div className='text-gray-700 font-semibold text-base'>Top Menu</div>
					<div className='mt-4 grid grid-cols-2 gap-3 mb-4'>
						{filteredProduct?.map((product, index) => {
							return <BigProduct key={index} {...{ product, gps }} />;
						})}
					</div>
				</>
			)}
		</div>
	);
};

export default TopMenu;
